import React from 'react';
import { Plus, X } from 'lucide-react';
import SubcategorySelect from './SubcategorySelect';

const selectCls = 'w-full border border-gray-300 rounded-md px-3 py-2 text-sm disabled:bg-gray-100 disabled:text-gray-400';

export const ExtraCategoriesField = ({ categories, primaryCategory, value, onChange }) => {
  const rows = value || [];
  const available = categories.filter(c => c.slug !== primaryCategory);
  const update = (idx, patch) => onChange(rows.map((r, i) => (i === idx ? { ...r, ...patch } : r)));
  const remove = (idx) => onChange(rows.filter((_, i) => i !== idx));
  const add = () => {
    const first = available.find(c => !rows.some(r => r.category === c.slug)) || available[0];
    if (first) onChange([...rows, { category: first.slug, subcategory: '' }]);
  };

  return (
    <div className="md:col-span-2 border border-dashed border-gray-300 rounded-lg p-3 bg-gray-50" data-testid="product-extra-categories">
      <div className="flex items-center justify-between mb-2">
        <div>
          <p className="text-xs font-medium text-gray-700">Catégories supplémentaires <span className="ml-1 text-[9px] font-bold uppercase tracking-wide bg-gray-700 text-white rounded-full px-1.5 py-0.5">Manuelle</span></p>
          <p className="text-[11px] text-gray-500">Associations choisies par vous : elles sont toujours conservées. Une sous-catégorie choisie ici déclenche aussi ses associations automatiques.</p>
        </div>
        <button type="button" onClick={add} disabled={!available.length} data-testid="product-extra-category-add" className="inline-flex items-center gap-1 text-xs font-medium text-orange-600 hover:text-orange-700 disabled:text-gray-400">
          <Plus className="w-3.5 h-3.5" /> Ajouter une catégorie
        </button>
      </div>
      {rows.length === 0 && <p className="text-xs text-gray-400" data-testid="product-extra-categories-empty">Aucune catégorie supplémentaire.</p>}
      <div className="space-y-2">
        {rows.map((row, idx) => {
          return (
            <div key={idx} className="grid grid-cols-1 sm:grid-cols-[1fr_1fr_auto] gap-2 items-center" data-testid={`product-extra-category-row-${idx}`}>
              <select data-testid={`product-extra-category-select-${idx}`} value={row.category} onChange={e => update(idx, { category: e.target.value, subcategory: '' })} className={selectCls}>
                {available.map(c => <option key={c.slug} value={c.slug}>{c.name}</option>)}
              </select>
              <SubcategorySelect testId={`product-extra-subcategory-select-${idx}`} category={categories.find(c => c.slug === row.category)} value={row.subcategory || ''} onChange={e => update(idx, { subcategory: e.target.value })} className={selectCls} emptyLabel="Toute la catégorie" />
              <button type="button" onClick={() => remove(idx)} data-testid={`product-extra-category-remove-${idx}`} className="p-2 text-gray-400 hover:text-red-600" aria-label="Retirer">
                <X className="w-4 h-4" />
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};
